import React from 'react';

interface OccConflictModalProps {
  isOpen: boolean;
  onRefresh: () => void;
  onCancel: () => void;
}

export const OccConflictModal: React.FC<OccConflictModalProps> = ({ isOpen, onRefresh, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="conflict-title">
      <div className="modal-card">
        <h3 id="conflict-title" style={{ color: '#d97706', display: 'flex', alignItems: 'center', gap: '8px' }}>
          ⚠️ Rekord został zmieniony w innym miejscu
        </h3>
        <p style={{ fontSize: '0.9rem', color: 'var(--text-main)', lineHeight: '1.5' }}>
          Wykryto nowszą wersję tego zlecenia w bazie danych (konflikt wersji OCC). Odśwież dane z serwera, aby przejrzeć najnowsze zmiany przed ponownym zapisem.
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '8px' }}>
          <button type="button" className="btn btn-outline" onClick={onCancel}>
            Anuluj
          </button>
          <button type="button" className="btn btn-primary" onClick={onRefresh}>
            Odśwież dane z CRM
          </button>
        </div>
      </div>
    </div>
  );
};
